// extracted by mini-css-extract-plugin
export default {"main":"DSU7Z"};